import {HyperDropComponent} from "./HyperDropComponent";

export class HyperDropAccordion extends HyperDropComponent {

  isOpen: boolean = false;
  toggleButton: HTMLElement;
  content: HTMLElement;

  openClass: string = 'open';

  onMount(): void {
    this.elements.toggleButton = this.elements.accordion.querySelector('.accordion-header');
    if(!this.elements.toggleButton) throw new Error('Accordion toggle not found');
    this.elements.content = this.elements.accordion.querySelector('.accordion-content');

    this.elements.toggleButton.addEventListener("click", this.toggle.bind(this));
  }
  toggle() {
    if(this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.elements.accordion.classList.add(this.openClass);
    this.isOpen = true;

    this.emit(this.elements.accordion,"accordion:open", { accordion: this});
  }

  close() {
    this.elements.accordion.classList.remove(this.openClass);
    this.isOpen = false;

    this.emit(this.elements.accordion,"accordion:close", { accordion: this});

  }
}
